export const buildPreAlarmContextPresentation = (context) => {
  if (!context || typeof context !== 'object') return null;
  const finiteNumber = value => value == null || value === '' || !Number.isFinite(Number(value)) ? null : Number(value);
  const spanSec = finiteNumber(context.span_sec);
  const requestedSpanSec = finiteNumber(context.requested_span_sec);
  const validSamples = finiteNumber(context.valid_samples);
  const zeroSamples = finiteNumber(context.zero_samples);
  if ([spanSec, requestedSpanSec, validSamples, zeroSamples].some(value => value === null)) return null;
  return {
    spanSec,
    partial: spanSec < requestedSpanSec,
    insufficient: validSamples < Math.max(10, (spanSec / 2) * 0.2),
    noDetectionPct: validSamples > 0 ? zeroSamples / validSamples * 100 : null,
    positiveMedian: finiteNumber(context.positive_median),
    positiveMax: finiteNumber(context.positive_max),
    hadPreviousAlarm: Number(context.alarm_samples) > 0,
  };
};
